import { QuestionBase } from './question-base';

export class NestedGroupQuestion extends QuestionBase<string> {
  controlType = 'nestedGroupQuestion';
  nestedQuestions: QuestionBase<any>[];

  constructor(options: any = {}) {
    super(options);
    this.nestedQuestions = options['nestedQuestions'] || [];
  }
}
